module.exports = __webpack_public_path__ + "static/media/willo.04da3d17.mp4";